module.exports = __webpack_public_path__ + "static/media/mg.91e10ba0.svg";